// Exit time of the last game session if it ended with a higher balance (`act:game_exit` balanceDelta > 0),
// else null. Module-level so it survives the lobby unmounting while a game is open. Read by the
// reward-claim install toast (KZ-7369).
let winExitAt: number | null = null;
const listeners = new Set<() => void>();

export function setLastGameWinExitAt(exitAt: number | null): void {
  if (winExitAt === exitAt) return;
  winExitAt = exitAt;
  listeners.forEach((notify) => notify());
}

export const getLastGameWinExitAt = () => winExitAt;

export function subscribeLastGameWin(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
